export const makeImageUrlWithSize = (
  url: string,
  width: number,
  height: number,
): string => `${url}?height=${height}&width=${width}`
